export const LOCALES = ["ru", "en", "ko"];
export const DEFAULT_LOCALE = "en";

export function isLocale(value) {
  return typeof value === "string" && LOCALES.includes(value);
}

export function detectInitialLocale({ storage, nav } = {}) {
  const s =
    storage ?? (typeof window !== "undefined" ? window.localStorage : null);
  const n = nav ?? (typeof navigator !== "undefined" ? navigator : null);

  const stored = s ? s.getItem("lang") : null;
  if (isLocale(stored)) return stored;

  const navLang = n && n.language ? n.language.slice(0, 2) : null;
  if (isLocale(navLang)) return navLang;

  return DEFAULT_LOCALE;
}
